module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kj-actions"
  }, [(_vm.selectIndex === 1) ? _c('div', {
    staticClass: "kj-actions-btns"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.handleBargainForMyselfClick('_bargainFormyself', _vm.campaignInf.id)
      }
    }
  }, [_vm._v("参与活动,为自己砍价")])]) : (_vm.selectIndex === 2) ? _c('div', {
    staticClass: "kj-actions-btns"
  }, [_c('button', {
    on: {
      "click": _vm.handleAskHelpClick
    }
  }, [_vm._v("请朋友帮砍")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.showSelectButton
    }
  }, [_vm._v("立即购买")])]) : (_vm.selectIndex === 3) ? _c('div', {
    staticClass: "kj-actions-btns"
  }, [(_vm.isHelpFriendsShow) ? _c('button', {
    on: {
      "click": _vm.handleAskHelpClick
    }
  }, [_vm._v("帮他拉人")]) : _c('button', {
    on: {
      "click": function($event) {
        _vm.handleBargainForOtherClick('_bargainForMyFriends', _vm.currentPlay.id)
      }
    }
  }, [_vm._v("帮 TA 砍价")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.handleJoinYourselfClick
    }
  }, [_vm._v("我也要参与")])]) : (_vm.selectIndex === 4) ? _c('div', {
    staticClass: "kj-actions-btns"
  }, [_c('button', {
    on: {
      "click": _vm.handleAskHelpClick
    }
  }, [_vm._v("帮他拉人")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.handleJoinYourselfClick
    }
  }, [_vm._v("我也要参与")])]) : _vm._e(), _vm._v(" "), _c('yd-popup', {
    attrs: {
      "position": "center",
      "width": "auto"
    },
    model: {
      value: (_vm.isShowPublicInf),
      callback: function($$v) {
        _vm.isShowPublicInf = $$v
      },
      expression: "isShowPublicInf"
    }
  }, [_c('div', {
    staticClass: "kj-actions-tips"
  }, [_c('button', {
    staticClass: "kj-actions-close",
    on: {
      "click": function($event) {
        _vm.isShowPublicInf = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./close.svg")
    }
  })]), _vm._v(" "), (_vm.publicInf.qrcode_url) ? _c('img', {
    attrs: {
      "src": ("//" + (_vm.publicInf.qrcode_url))
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("或搜索公众号: " + _vm._s(_vm.publicInf.nick_name))]), _vm._v(" "), _c('p', {
    staticClass: "kj-actions-tips_big"
  }, [_vm._v("回复关键字 "), _c('b', [_vm._v(_vm._s(_vm.campaignInf.wechat_keyword))]), _vm._v(" 参与活动")])])]), _vm._v(" "), _c('yd-popup', {
    attrs: {
      "position": "bottom",
      "height": "auto"
    },
    model: {
      value: (_vm.contentShow),
      callback: function($$v) {
        _vm.contentShow = $$v
      },
      expression: "contentShow"
    }
  }, [_c('div', {
    staticClass: "kj-actions-info"
  }, [_c('button', {
    staticClass: "kj-actions-close",
    on: {
      "click": function($event) {
        _vm.contentShow = false
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./close.svg")
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "kj-actions-info_head"
  }, [_vm._v("活动说明")]), _vm._v(" "), _c('div', {
    staticClass: "kj-actions-info_box"
  }, [_c('div', {
    staticClass: "kj-actions-info_item"
  }, [_c('div', {
    staticClass: "kj-actions-info_label"
  }, [_vm._v("方法1:")]), _vm._v(" "), _c('div', {
    staticClass: "kj-actions-info_cont"
  }, [_c('p', [_vm._v("长按下图保存发给朋友们")]), _vm._v(" "), _c('div', {
    staticClass: "kj-actions-info_imgs"
  }, [_c('div', {
    staticClass: "kj-actions-info_share_img-wrap"
  }, [(_vm.base64Img) ? _c('img', {
    staticClass: "kj-actions-info_share_img",
    style: ({
      opacity: _vm.base64Img ? 1 : 0
    }),
    attrs: {
      "crossorigin": "anonymous",
      "id": "kj-canvas-img",
      "src": _vm.base64Img
    }
  }) : _vm._e()]), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "kj-canvas",
      "width": "540",
      "height": "815"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "kj-actions-info_arrow",
    attrs: {
      "src": require("./arrow.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "kj-actions-info_item"
  }, [_c('div', {
    staticClass: "kj-actions-info_label"
  }, [_vm._v("方法2:")]), _vm._v(" "), _c('div', {
    staticClass: "kj-actions-info_cont"
  }, [_c('p', [_vm._v("复制以下链接发给朋友们")]), _vm._v(" "), _c('div', {
    staticClass: "kj-actions-info_copy"
  }, [_vm._v("我非常想要这个宝贝，大家快来帮我砍个价，能省一点是一点，猛戳链接：" + _vm._s(this.shortUrl))])])])])])]), _vm._v(" "), _c('TkSkuPopup', {
    attrs: {
      "type": "cart",
      "product-id": _vm.item.product_id,
      "sku": _vm.item.variant_id,
      "quantity": _vm.item.quantity,
      "amountAfter": _vm.currentPlay && _vm.currentPlay.amount_after
    },
    on: {
      "change": _vm.handleSelectCommodity
    },
    model: {
      value: (_vm.onOpt),
      callback: function($$v) {
        _vm.onOpt = $$v
      },
      expression: "onOpt"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cc6c0b0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/bargainButton/index.vue
// module id = 283
// module chunks = 0